import { render, staticRenderFns } from "./UserCenterPage.vue?vue&type=template&id=ca15fb1e&scoped=true"
import script from "./UserCenterPage.vue?vue&type=script&lang=js"
export * from "./UserCenterPage.vue?vue&type=script&lang=js"
import style0 from "./UserCenterPage.vue?vue&type=style&index=0&id=ca15fb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca15fb1e",
  null
  
)

export default component.exports